module.exports = __webpack_public_path__ + "static/media/loading-2.7c876459.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-2.svg
// module id = 87
// module chunks = 7